import { ConfigStateService, PermissionService } from '@abp/ng.core';
import { AbpOAuthService } from '@abp/ng.oauth';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import Clarity from '@microsoft/clarity';
import { Store } from '@ngrx/store';
import { CustomService } from '@proxy/custom.service';
import { environment } from 'src/environments/environment';
import { Roles } from '../core/model/role_contstant';
import { LoaderService } from '../core/services/loader.service';
import { LogUpdateService } from '../core/services/logUpdate.service';
import { AddressKeyService } from '../shared/service/addresskey.service';
import { AutoLogoutService } from '../shared/service/auto-logout.service';
import { SignalRService } from '../shared/signalR/signalr.service';
import { RootReducerState } from '../store';
import { CustomServiceService } from '../shared/service/custom.service';
import { Services } from '../core/model/service-contant';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

export class LayoutComponent implements OnInit {

  layoutType = 'vertical';
  currentUser: import('@abp/ng.core').CurrentUserDto;
  isAuthorized = false;

  constructor(private readonly store: Store<RootReducerState>,
    public abpOauthService: AbpOAuthService,
    private readonly config: ConfigStateService,
    private readonly router: Router,
    private readonly signalRService: SignalRService,
    private readonly customService: CustomService,
    private readonly swUpdate: SwUpdate,
    private readonly logService: LogUpdateService,
    private readonly autoLogout: AutoLogoutService,
    private readonly addressKeyService: AddressKeyService,
    public loaderService: LoaderService,
    private readonly customSharedService: CustomServiceService,
    public permissionService:PermissionService
  ) { }
  private cleanOAuthQueryParams() {
    const urlTree = this.router.parseUrl(this.router.url);
    const path = urlTree.root.children['primary']?.segments.map(it => it.path).join('/');
    if (path === 'nextere') {
      const issParam = urlTree.queryParams['iss'];
      if (issParam) {
        this.router.navigate(['/nextere'], {
          replaceUrl: true
        });
      }
    }
  }

  ngOnInit(): void {
    localStorage.setItem('route', 'nextere');

    this.currentUser = this.config.getOne('currentUser');
    this.abpOauthService.init();


    if (!this.abpOauthService.isAuthenticated) {
      this.abpOauthService.navigateToLogin();
      return;
    }

    if (!this.currentUser.roles.includes(Roles.Admin)) {
      this.authorized();
      if (this.permissionService.getGrantedPolicy('Lead.AgentWallet')) {
        this.router.navigate([localStorage.getItem('route'), 'wallet']);
      }
    }

    this.signalRService.initializeConnection(this.abpOauthService.getAccessToken());
    this.setWidget();
    this.autoLogout.resetTimer();

    this.addressKeyService.getKey().subscribe((res) => {
      this.addressKeyService.addressKey = res?.addresskey;
    });

    this.cleanOAuthQueryParams();

    // Load Zoho Widget Token
    const token = localStorage.getItem('access_token');
    const headers = { Authorization: `Bearer ${token}` };

    const getJwtTokenCallback = (
      successCallback: (token: string) => void,
      failureCallback: (error: any) => void
    ) => {
      fetch(environment.widgetURL, { headers })
        .then((response) => response.json())
        .then((data) => {
          successCallback(data.token);
        })
        .catch((error) => {
          failureCallback(error);
        });
    };

    (window as any).ZohoDeskAsapReady(() => {
      (window as any).ZohoDeskAsap.invoke("login", getJwtTokenCallback);
    });

    if (this.swUpdate.isEnabled) {
      setInterval(() => {
        this.logService.update();
      }, 5000);
    }

    if (environment.clarityProjectId != null) {
      Clarity.init(environment.clarityProjectId);
      Clarity.identify(this.currentUser.email);
      this.setScript();
    }

    this.store.select("layout").subscribe((data) => {
      this.layoutType = data.LAYOUT;

      document.documentElement.setAttribute("data-layout", data.LAYOUT);
      document.documentElement.setAttribute("data-bs-theme", data.LAYOUT_MODE);
      document.documentElement.setAttribute("data-layout-width", data.LAYOUT_WIDTH);
      document.documentElement.setAttribute("data-layout-position", data.LAYOUT_POSITION);
      document.documentElement.setAttribute("data-topbar", data.TOPBAR);

      if (data.LAYOUT === "vertical" || data.LAYOUT === "twocolumn") {
        document.documentElement.setAttribute("data-sidebar", data.SIDEBAR_COLOR);
        document.documentElement.setAttribute("data-sidebar-size", data.SIDEBAR_SIZE);
        document.documentElement.setAttribute("data-sidebar-image", data.SIDEBAR_IMAGE);
        document.documentElement.setAttribute("data-layout-style", data.SIDEBAR_VIEW);
      }

      document.documentElement.setAttribute("data-preloader", data.DATA_PRELOADER);
      document.documentElement.setAttribute("data-sidebar-visibility", data.SIDEBAR_VISIBILITY);
      document.documentElement.setAttribute("data-body-image", data.BODY_IMAGE);
    });
  }

   async authorized() {
   
      this.customSharedService.getUserPermission(Services.Lead).subscribe((res: any) => {
        this.isAuthorized = res.isAuthorized;
        localStorage.setItem('grantedService', JSON.stringify(res.grantedServices))
        if (!res.isAuthorized) {
          document.documentElement.style.setProperty('--vz-vertical-menu-width', '0');
          document.documentElement.style.setProperty('--vz-vertical-menu-width-md', '0');
          document.documentElement.style.setProperty('--vz-vertical-menu-width-sm', '0');
          this.router.navigate([localStorage.getItem('route'), 'permission-denied'])
        } else if (this.router.url.includes('permission-denied')) {
          this.router.navigate([localStorage.getItem('route')])
        }
      })
  
  }

  checkUrlRedirect() {
    const routeParam = localStorage.getItem('route');
    const currentFullUrl = this.router.url;

    if (!currentFullUrl.includes(`/${routeParam}`)) {
      this.router.navigateByUrl(`/${routeParam}${currentFullUrl}`);
    }
  }

  colorPalatechanges() {
    this.customService.getColorConfigurationSetting().subscribe((res) => {
      let rgba: any = res.primaryColor.match(/\d+/g).map(Number)
      let temp = rgba[0] + ',' + rgba[1] + ',' + rgba[2]
      if (res.isPrimaryGradient) {
        const gradient = `linear-gradient(90deg, ${res.primaryColor}, ${res.primaryGradientColor})`;
        document.documentElement.style.setProperty('--kendo-color-primary', gradient);
      } else {
        document.documentElement.style.setProperty('--kendo-color-primary', res.primaryColor);
      }
      document.documentElement.style.setProperty('--vz-primary', res.primaryColor);
      document.documentElement.style.setProperty('--vz-light', res.secondaryColor);
      document.documentElement.style.setProperty('--vz-primary-rgb', temp);
      document.documentElement.style.setProperty('--vz-primary-border-color', temp);
      document.documentElement.style.setProperty('--vz-vertical-menu-bg', res.sidebarColor);
      document.documentElement.style.setProperty('--vz-btn-disabled-bg', res.primaryColor);
      document.documentElement.style.setProperty('--vz-btn-disabled-border-color', res.primaryColor);
      document.documentElement.style.setProperty('--vz-primary-text-emphasis', res.primaryColor);
      document.documentElement.style.setProperty('--vz-link-color', res.primaryColor);
      document.documentElement.style.setProperty('--vz-link-active-color', res.primaryColor);
      document.documentElement.style.setProperty('--vz-vertical-menu-item-color', res.sidebarMenuTextColor);
      document.documentElement.style.setProperty('--vz-vertical-menu-sub-item-color', res.sidebarMenuTextColor);
      document.documentElement.style.setProperty('--vz-vertical-menu-border', res.sidebarColor);
      document.documentElement.style.setProperty('--vz-link-hover-color', res.primaryColor);
    })
  }

  setWidget() {
    const randomBytes = new Uint8Array(16);
    crypto.getRandomValues(randomBytes);
    const nonceValue = btoa(String.fromCharCode(...randomBytes));
    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.id = 'zohodeskasapscript';
    scriptElement.defer = true;
    scriptElement.nonce = nonceValue;
    scriptElement.src = 'https://desk.zoho.com/portal/api/web/asapApp/1045107000001411024?orgId=866597574';
    (window as any).ZohoDeskAsapReady = function (callback: Function | undefined) {
      const asyncCalls = ((window as any).ZohoDeskAsap__asyncalls ?? []);
      (window as any).ZohoDeskAsap__asyncalls = asyncCalls;

      if ((window as any).ZohoDeskAsapReadyStatus) {
        callback && asyncCalls.push(callback);
        asyncCalls.forEach((cb: Function | undefined) => cb?.());
        (window as any).ZohoDeskAsap__asyncalls = null;
      } else {
        callback && asyncCalls.push(callback);
      }
    };
    document.body.appendChild(scriptElement);
  }

  setScript() {
    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';

    scriptElement.addEventListener('load', () => {
      (function (window: Window, document: Document, clarity: string, script: string, id: string) {
        (window as any)[clarity] = (window as any)[clarity] ?? function () {
          (window as any)[clarity].q = (window as any)[clarity].q ?? [];
          (window as any)[clarity].q.push(arguments);
        };

        const clarityTag: HTMLScriptElement = document.createElement(script) as HTMLScriptElement;
        clarityTag.async = true;
        clarityTag.src = `https://www.clarity.ms/tag/${id}`;

        const firstScript = document.getElementsByTagName(script)[0];
        firstScript.parentNode.insertBefore(clarityTag, firstScript);
      })(window, document, 'clarity', 'script', 'spjzvy04k9');
    });

    document.body.appendChild(scriptElement);
  }
}
